var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3713_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.00018C5 1.89561 5.89543 1.00018 7 1.00018H19C20.1046 1.00018 21 1.89561 21 3.00018V15.0002C21 16.1048 20.1046 17.0002 19 17.0002H7C5.89543 17.0002 5 16.1048 5 15.0002V3.00018Z",
    fill: "#FCFCFC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.00018C5.5 2.17176 6.17157 1.50018 7 1.50018H19C19.8284 1.50018 20.5 2.17176 20.5 3.00018V15.0002C20.5 15.8286 19.8284 16.5002 19 16.5002H7C6.17157 16.5002 5.5 15.8286 5.5 15.0002V3.00018Z",
    stroke: "#E0DDEE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3767 6.97771V11.0227L15.6393 6.97771V11.0227L10.3767 6.97771Z",
    fill: "#002D62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1627 6.54794C10.3321 6.46816 10.5334 6.48955 10.681 6.60303L13.008 8.39159L15.3349 6.60303C15.4826 6.48955 15.6839 6.46816 15.8532 6.54794C16.0226 6.62773 16.1301 6.79467 16.1301 6.97771V11.0227C16.1301 11.2057 16.0226 11.3726 15.8532 11.4524C15.6839 11.5322 15.4826 11.5108 15.3349 11.3973L13.008 9.60878L10.681 11.3973C10.5334 11.5108 10.3321 11.5322 10.1627 11.4524C9.9934 11.3726 9.88585 11.2057 9.88585 11.0227V6.97771C9.88585 6.79467 9.9934 6.62773 10.1627 6.54794ZM12.2162 9.00018L10.8676 7.9636V10.0368L12.2162 9.00018ZM13.7998 9.00018L15.1484 10.0368V7.9636L13.7998 9.00018Z",
    fill: "#002D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.38159H16.0031V8.61756H18V9.38159Z",
    fill: "#002D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.38159H10.0057V8.61756H8V9.38159Z",
    fill: "#002D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3713_2308",
    x: 0,
    y: 0.000183105,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3713_2308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3713_2308",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureIcon);
export default __webpack_public_path__ + "static/media/pressureIcon.c9ffd09779f9b085a6badc63a8ec8ab1.svg";
export { ForwardRef as ReactComponent };